import React from 'react'

import { createCanonicalPdpUrl } from '../../../../app/_components/navigation/createPdpUrl'
import { SeoMeta } from '../../../../components/SeoMeta'

export interface KitPageMetaProps {
  description?: string
  handle: string
  image?: string
  noindex?: boolean
  seoDescription?: string
  seoTitle?: string | undefined | null
  title?: string
  video?: string
}

export const KitPageMeta: React.FC<KitPageMetaProps> = ({
  description,
  handle,
  image,
  noindex,
  seoDescription,
  seoTitle,
  title,
  video,
}) => {
  const canonicalUrl = createCanonicalPdpUrl({
    productGroupHandle: handle,
    isKit: true,
    isExclusive: false,
    genderKey: undefined, // Gender is important if we start supporting isExclusive here.
  })

  return (
    <SeoMeta
      canonicalUrl={canonicalUrl}
      image={image}
      noindex={noindex}
      video={video}
      description={seoDescription || description}
      imageAlt={description}
      title={seoTitle?.trim().length ? seoTitle : title}
    />
  )
}
